import { USER } from 'utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { signIn, setCopyright } from 'redux/auth/authSlice';
import { signOutAsync } from 'redux/auth/authActions';
import { getFromSecureStorage } from 'utils/storage';

export const useIsLoggedIn = () => {
    const { user } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const isSignedIn = () => {
        const session = getFromSecureStorage(USER);
        if (!user && session) {
            dispatch(setCopyright(true));
            dispatch(signIn(JSON.parse(session)));
        }
        return JSON.parse(session);
    };

    return isSignedIn();
};

export const useSignOut = () => {
    const dispatch = useDispatch();
    
    const signout = () => {
        dispatch(signOutAsync());
    };

    return signout;
};
